import { Page } from '@/core/architecture'

import { ConsoleOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleOrders Page
 * Implemented as a practical sample.
 */
export const ConsoleOrders: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleOrdersTemplate state={state} {...actions} />
}
